// Sharing an album must not inherit a comment location or temporary page query.
// Prefer the same canonical identity as the anonymous preview service.
export const albumSharePath = (album) => {
  if (album?.slug) return `/reviews/${encodeURIComponent(album.slug)}`;
  if (Number.isSafeInteger(album?.id) && album.id > 0) return `/reviews/local/${album.id}`;
  const source = album?.albumSource?.toLowerCase();
  if (['apple_music', 'spotify', 'postpop'].includes(source) && album?.sourceId) {
    return `/reviews/${source}/${encodeURIComponent(album.sourceId)}`;
  }
  return undefined;
};
